const managePromotion = {
  managePromotion: {
    pageTitle: '프로모션 관리',
    description: '프로모션을 추가, 수정, 삭제하고 활성화 상태를 관리합니다.',
    searchPlaceholder: '제목 또는 설명으로 검색',
    buttons: {
      reset: '초기화',
      deleteSelected: '선택 삭제 {{count}}',
      addPromotion: '프로모션 추가',
      edit: '수정',
      delete: '삭제'
    },
    imageFallback: {
      loadFailed: '로드 실패',
      checkNetwork: '네트워크 탭 확인',
      loading: '로딩 중...',
      noImage: '이미지 없음'
    },
    alerts: {
      saveFailed: '저장에 실패했습니다. 다시 시도해주세요.',
      deleteFailed: '삭제에 실패했습니다. 다시 시도해주세요.',
      statusUpdateFailed: '상태 변경에 실패했습니다. 다시 시도해주세요.',
    }
  }
};

export default managePromotion;